import type {
  SearchFilterCondition,
  SearchFilterConditionCustomAttribute,
  SearchFilterField,
  SearchFilterOperator,
} from 'lib-shared-types-api';

import { filterOperatorGroups } from '../../components/filters/utils/definitions';

/** Checks if the given operator is nullish */
export function isNullishFilterOperator(
  operator: SearchFilterOperator,
): operator is (typeof filterOperatorGroups.nullish)[number] {
  return filterOperatorGroups.nullish.includes(
    operator as (typeof filterOperatorGroups.nullish)[number],
  );
}

/** Checks if the given condition is a custom attribute condition */
export function isCustomAttributeCondition(
  condition: SearchFilterCondition,
): condition is SearchFilterConditionCustomAttribute {
  return isCustomAttributeField(condition.field);
}

/** Checks if the given condition field is a custom attribute field. */
export function isCustomAttributeField(field: SearchFilterField): boolean {
  return (
    field === 'conversation_custom_attribute' ||
    field === 'contact_custom_attribute'
  );
}
